class TransactionsApi {

  constructor(authToken) {
    this.authToken = authToken;
  }

  headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  BASE_URL = 'https://d2bazeiz5asygt.cloudfront.net/transactions';

  createHeaders() {
    return this.authToken ? {
      ...this.headers,
      'Authorization': 'Bearer ' + this.authToken
    } : this.headers;
  }

  async findById(id) {
    return await fetch(`${this.BASE_URL}/findById?propertyId=${id}`, {
      method: 'GET',
      headers: this.createHeaders()
    });
  }

  async recent(limit, zip) {
    const params = new URLSearchParams();
    if (limit) {
      params.set('limit', limit);
    }
    if (zip) {
      params.set('zip', zip);
    }
    const queryString = params.toString();
    return await fetch(`${this.BASE_URL}/recent${queryString ? `?${queryString}` : ''}`, {
      method: 'GET',
      headers: this.createHeaders()
    });
  }
}

export default TransactionsApi;